import { Theme } from './theme'

export const breakpointsRange = (theme: Theme): [string, string] => [
  theme.breakpoints[0],
  theme.breakpoints[theme.breakpoints.length - 1],
]
